
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'sliceName',
    standalone: false
})
export class SliceNamePipe implements PipeTransform {

  transform(value: string): string {
    const parts: string[] = value.split(' ');
    let result: string = '';

    if (parts.length > 1) {
      result = parts[0] + ' ' + parts[1];
    } else {
      result = parts.length > 0 ? parts[0] : '';
    }

    if (result.length > 20) {
      result = result.slice(0, 20) + '...';
    } else {
      result = result;
    }

    return result;
   }
}
